<template>
  <li class="nav-item">
    <router-link
      v-tooltip.right="collapsed && !isMobileTablet ? 'Alerts' : false"
      to="/tasks"
      class="nav-link u-mr-8 text-nowrap d-flex align-items-center"
      :class="{ 'router-link-active': $route.path.startsWith('/tasks') }"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      @click="$emit('navigated')"
    >
      <i class="fa fa-bell app-sidebar__icon" aria-hidden="true" />
      <span class="app-sidebar__label">Alerts</span>
      <span
        v-show="showBadge"
        class="badge badge-pill badge-theme ml-1 app-sidebar__badge"
      >
        {{ numberOfUnreadTasks ? numberOfUnreadTasks : "0" }}
      </span>
    </router-link>
  </li>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["navigated"],
  computed: {
    ...mapState({
      numberOfUnreadTasks: (state) => state.task.numberOfUnreadTasks,
      deviceType: (state) => state.settings.deviceType,
    }),
    showBadge: function () {
      return this.numberOfUnreadTasks;
    },
    isMobileTablet: function () {
      return this.deviceType == "mobile" || this.deviceType == "tablet";
    },
  },
  mounted() {
    this.getMyUnreadTasksCount();
    setInterval(() => {
      this.getMyUnreadTasksCount();
    }, 30000);
  },
  methods: {
    ...mapActions({
      getMyUnreadTasksCount: "task/getMyUnreadTasksCount",
    }),
  },
};
</script>
<style lang="scss" scoped>
.badge-theme {
  background-color: var(--theme-color);
  color: var(--btn-text-color);
  font-size: 12px;
}
</style>
